import { Link } from "react-router";
import type { Locale } from "../../shared/api/types";
import type { ReleaseNote } from "./releases";
import { formatGoLive, whatsNewText } from "./whatsNewText";

/**
 * Release entries in the given language (Thai for everyone, ruling of 18 Oct 2026): the release number and PRD go-live date, the headline, the bullets and the GRF
 * items it closed (each a link to the item). Shared by the /whats-new page (h2 per release) and the dialog (h3).
 */
export function ReleaseList({ releases, locale, level, onFollowLink }: { releases: readonly ReleaseNote[]; locale: Locale; level: 2 | 3; onFollowLink?: () => void }) {
  const Heading = level === 2 ? "h2" : "h3";
  return (
    <div className="gf-releases">
      {releases.map((release) => {
        const id = `release-${release.batch}`;
        return (
          <article key={release.batch} className="gf-release" aria-labelledby={id} data-release={release.batch}>
            <Heading id={id} className="gf-release-head">
              <span>{whatsNewText("release", locale, { batch: release.batch })}</span>
              {release.goLive && <span className="gf-release-date">{whatsNewText("liveOn", locale, { date: formatGoLive(release.goLive, locale) })}</span>}
            </Heading>
            <p className="gf-release-headline">{release.headline[locale]}</p>
            <ul className="gf-release-bullets">
              {release.bullets.map((bullet) => (
                <li key={bullet.en}>{bullet[locale]}</li>
              ))}
            </ul>
            {release.closed.length > 0 && (
              <p className="gf-release-closed">
                <span>{whatsNewText("closed", locale)}</span>{" "}
                {release.closed.map((key, index) => (
                  <span key={key}>
                    {index > 0 && ", "}
                    <Link to={`/items/${encodeURIComponent(key)}`} onClick={onFollowLink}>
                      {key}
                    </Link>
                  </span>
                ))}
              </p>
            )}
          </article>
        );
      })}
    </div>
  );
}
